"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function dcGoBack($state, NavigationHistoryService) {
    return {
        restrict: "A",
        scope: {},
        link: function (scope, element, attrs) {
            // root scope on change stuff was moved to the app.start file around line 27
            // original reference: http://stackoverflow.com/questions/16635381/angularjs-ui-route-get-previous-state
            // secondary reference: http://stackoverflow.com/questions/14070285/how-to-implement-history-back-in-angular-js
            element.on("click", function () {
                if (NavigationHistoryService.previousState.params) {
                    $state.go(NavigationHistoryService.previousState.name, NavigationHistoryService.previousState.params);
                }
                else {
                    $state.go(NavigationHistoryService.previousState.name);
                }
            });
        },
    };
}
dcGoBack.$inject = ["$state", "NavigationHistoryService"];
exports.default = dcGoBack;
